import React, { Component } from "react";
import FaqAnswer from "./faq-answer";
import "./style.css";
import womandesktop from "../images/illustration-woman-desktop.svg";
import boxdesktop from "../images/illustration-box-desktop.svg";
import patterndesktop from "../images/bg-pattern-desktop.svg";
import patternmobile from "../images/bg-pattern-mobile.svg";
import womanmobile from "../images/illustration-woman-mobile.svg";

class FaqPod extends Component {
  boxHoverAni = () => {
    var boxImg = document.querySelector(".box-img");
    boxImg.style.animation = "bounce 1.5s ease 1";
  };
  boxHoverAniOut = () => {
    var boxImg = document.querySelector(".box-img");
    boxImg.style.animation = "initial";
  };

  togglesSwitch = () => {
    var faqShow = document.querySelector(".faq-card");
    var faqShow2 = document.querySelector(".faq-card2");
    var faqShow3 = document.querySelector(".faq-card3");
    var faqShow4 = document.querySelector(".faq-card4");
    var faqShow5 = document.querySelector(".faq-card5");

    faqShow.classList.add("card-active");
    faqShow2.classList.remove("card-active");
    faqShow3.classList.remove("card-active");
    faqShow4.classList.remove("card-active");
    faqShow5.classList.remove("card-active");
    if (faqShow.classList.contains("card-active")) {
      document.querySelector(".faq-card img").style.transform =
        "scale(0.5) translateY(-12px) rotate(180deg)";
      document.querySelector(".faq-card2 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card3 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card4 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card5 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";

      document.querySelector(".faq-card p").style.color = "hsl(349deg 87% 54%)";
      document.querySelector(".faq-card2 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card3 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card4 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card5 p").style.color =
        "var(--Verydarkgrayishblue)";
    }
  };
  togglesSwitch2 = () => {
    var faqShow = document.querySelector(".faq-card");
    var faqShow2 = document.querySelector(".faq-card2");
    var faqShow3 = document.querySelector(".faq-card3");
    var faqShow4 = document.querySelector(".faq-card4");
    var faqShow5 = document.querySelector(".faq-card5");

    faqShow.classList.remove("card-active");
    faqShow2.classList.add("card-active");
    faqShow3.classList.remove("card-active");
    faqShow4.classList.remove("card-active");
    faqShow5.classList.remove("card-active");
    if (faqShow2.classList.contains("card-active")) {
      document.querySelector(".faq-card img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card2 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(180deg)";
      document.querySelector(".faq-card3 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card4 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card5 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";

      document.querySelector(".faq-card p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card2 p").style.color =
        "hsl(349deg 87% 54%)";
      document.querySelector(".faq-card3 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card4 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card5 p").style.color =
        "var(--Verydarkgrayishblue)";
    }
  };
  togglesSwitch3 = () => {
    var faqShow = document.querySelector(".faq-card");
    var faqShow2 = document.querySelector(".faq-card2");
    var faqShow3 = document.querySelector(".faq-card3");
    var faqShow4 = document.querySelector(".faq-card4");
    var faqShow5 = document.querySelector(".faq-card5");

    faqShow.classList.remove("card-active");
    faqShow2.classList.remove("card-active");
    faqShow3.classList.add("card-active");
    faqShow4.classList.remove("card-active");
    faqShow5.classList.remove("card-active");
    if (faqShow3.classList.contains("card-active")) {
      document.querySelector(".faq-card img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card2 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card3 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(180deg)";
      document.querySelector(".faq-card4 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card5 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";

      document.querySelector(".faq-card p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card2 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card3 p").style.color =
        "hsl(349deg 87% 54%)";
      document.querySelector(".faq-card4 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card5 p").style.color =
        "var(--Verydarkgrayishblue)";
    }
  };
  togglesSwitch4 = () => {
    var faqShow = document.querySelector(".faq-card");
    var faqShow2 = document.querySelector(".faq-card2");
    var faqShow3 = document.querySelector(".faq-card3");
    var faqShow4 = document.querySelector(".faq-card4");
    var faqShow5 = document.querySelector(".faq-card5");

    faqShow.classList.remove("card-active");
    faqShow2.classList.remove("card-active");
    faqShow3.classList.remove("card-active");
    faqShow4.classList.add("card-active");
    faqShow5.classList.remove("card-active");
    if (faqShow4.classList.contains("card-active")) {
      document.querySelector(".faq-card img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card2 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card3 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card4 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(180deg)";
      document.querySelector(".faq-card5 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";

      document.querySelector(".faq-card p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card2 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card3 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card4 p").style.color =
        "hsl(349deg 87% 54%)";
      document.querySelector(".faq-card5 p").style.color =
        "var(--Verydarkgrayishblue)";
    }
  };
  togglesSwitch5 = () => {
    var faqShow = document.querySelector(".faq-card");
    var faqShow2 = document.querySelector(".faq-card2");
    var faqShow3 = document.querySelector(".faq-card3");
    var faqShow4 = document.querySelector(".faq-card4");
    var faqShow5 = document.querySelector(".faq-card5");

    faqShow.classList.remove("card-active");
    faqShow2.classList.remove("card-active");
    faqShow3.classList.remove("card-active");
    faqShow4.classList.remove("card-active");
    faqShow5.classList.add("card-active");
    if (faqShow5.classList.contains("card-active")) {
      document.querySelector(".faq-card img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card2 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card3 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card4 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(0deg)";
      document.querySelector(".faq-card5 img").style.transform =
        "scale(0.5) translateY(-12px) rotate(180deg)";

      document.querySelector(".faq-card p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card2 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card3 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card4 p").style.color =
        "var(--Verydarkgrayishblue)";
      document.querySelector(".faq-card5 p").style.color =
        "hsl(349deg 87% 54%)";
    }
  };

  render() {
    return (
      <div className="faq-img-container">
        <img src={boxdesktop} className="box-img" alt="" />
        <div
          className="faq-container"
          onMouseOver={this.boxHoverAni}
          onMouseOut={this.boxHoverAniOut}
        >
          <div className="faq-section1">
            <img src={womandesktop} className="women-large-img" alt="" />
            <img src={patterndesktop} className="pattern-large-img" alt="" />
            <img src={womanmobile} className="women-mobile-img" alt="" />
            <img src={patternmobile} className="pattern-mobile-img" alt="" />
          </div>
          <div className="faq-section2">
            <h1>faq</h1>
            <div className="faq-section2-container">
              <div onClick={this.togglesSwitch}>
                <FaqAnswer
                  class="faq-card card-active"
                  question="How many team members can I invite?"
                  answer="You can invite up to 2 additional users on the Free plan. There is no limit on team members for the Premium plan."
                />
              </div>
              <div onClick={this.togglesSwitch2}>
                <FaqAnswer
                  class="faq-card2"
                  question="What is the maximum file upload size?"
                  answer="No more than 2GB. All files in your account must fit your allotted storage space."
                />
              </div>
              <div onClick={this.togglesSwitch3}>
                <FaqAnswer
                  class="faq-card3"
                  question="How do I reset my password?"
                  answer="  Click “Forgot password” from the login page or “Change password” from your profile page.
                A reset link will be emailed to you."
                />
              </div>
              <div onClick={this.togglesSwitch4}>
                <FaqAnswer
                  class="faq-card4"
                  question="Can I cancel my subscription?"
                  answer="Yes! Send us a message and we’ll process your request no questions asked."
                />
              </div>
              <div onClick={this.togglesSwitch5}>
                <FaqAnswer
                  class="faq-card5"
                  question="Do you provide additional support?"
                  answer="Chat and email support is available 24/7. Phone lines are open during normal business hours."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FaqPod;
